"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = void 0;
const react_1 = __importDefault(require("react"));
const pi_1 = require("react-icons/pi");
const sonner_1 = require("sonner");
const utils_1 = require("../../lib/utils");
const IconButton_1 = require("../Button/IconButton");
const variantIconMap = {
    success: {
        Icon: pi_1.PiThumbsUpBold,
        gradientStyle: "tw-fill-[url(#gradientV3)]",
    },
    error: {
        Icon: pi_1.PiWarningBold,
        gradientStyle: "tw-fill-[url(#gradientLavender)]",
    },
};
function Gradients() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("svg", { className: "tw-absolute tw-h-0 tw-w-0" },
            react_1.default.createElement("linearGradient", { id: "gradientV3", x1: "0%", y1: "0%", x2: "0%", y2: "100%" },
                react_1.default.createElement("stop", { stopColor: "#E3AEFF", offset: "0%" }),
                react_1.default.createElement("stop", { stopColor: "#36B5FF", offset: "100%" }))),
        react_1.default.createElement("svg", { className: "tw-absolute tw-h-0 tw-w-0" },
            react_1.default.createElement("linearGradient", { id: "gradientLavender", x1: "100%", y1: "0%", x2: "100%", y2: "100%" },
                react_1.default.createElement("stop", { stopColor: "#9B9BED", offset: "0%" }),
                react_1.default.createElement("stop", { stopColor: "#FF77A8", offset: "100%" })))));
}
function useToast() {
    function toast({ content, variant, }) {
        return sonner_1.toast.custom((toastId) => {
            const { Icon, gradientStyle } = variantIconMap[variant];
            return (react_1.default.createElement("div", { className: "tw-inline-flex tw-max-w-xl tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-bg-neutral-500 tw-px-6 tw-py-4 tw-font-sans tw-text-sm tw-font-semibold tw-text-neutral-25 tw-shadow-dropdown" },
                react_1.default.createElement(Gradients, null),
                react_1.default.createElement(Icon, { className: (0, utils_1.cn)("tw-h-5 tw-w-5 tw-shrink-0", gradientStyle) }),
                content,
                react_1.default.createElement(IconButton_1.IconButton, { size: "sm", color: "transparentWhite", Icon: pi_1.PiXBold, onClick: () => sonner_1.toast.dismiss(toastId) })));
        });
    }
    return toast;
}
exports.useToast = useToast;
